module.exports = __webpack_public_path__ + "img/camp01_open.d6e962ef.png";